import {Box, withStyles} from '@material-ui/core';
import {WithStyles} from '@material-ui/core/styles';
import classNames from 'classnames';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import size from 'lodash/size';
import React, {PropsWithChildren} from 'react';

import {messageBalloonStyles} from './messageBalloonStyles';

const MessageBalloon: React.FC<IMessageBalloonProps> = (props: IMessageBalloonProps) => {
	const arrowProps = {
		className: classNames([props.right ? props.classes.triangleRight : props.classes.triangle, '-triangle']),
		style: {
			[props.right ? 'right' : 'left']: props.arrowOffset,
		},
	};

	const showArrow =
		(isString(props.arrowOffset) && size(props.arrowOffset) > 0) ||
		(isNumber(props.arrowOffset) && props.arrowOffset >= 0);

	return (
		<div className={classNames([props.className, props.classes.root])}>
			<Box className={props.right ? props.classes.right : props.classes.left}>{props.children}</Box>
			{showArrow ? <div {...arrowProps} /> : null}
		</div>
	);
};

MessageBalloon.defaultProps = {
	right: false,
	arrowOffset: 0,
};

interface IMessageBalloonProps extends WithStyles, PropsWithChildren<any> {
	right?: boolean;
	className?: any;
	arrowOffset?: number | string;
}

export default withStyles(messageBalloonStyles)(MessageBalloon);
